import React from 'react';
import PageComponent from './Page';

const Sell = ({
  nextClickHandler,
  onAnalyseResultsClick,
  menuItems,
  selectComponent,
  componentIndex,
  rules,
  backPath,
  onDone,
  test,
  locales,
  locales: {
    testing: {
      name,
      titles,
      testPlan: {
        header,
        sell: { text, title, footer, cardTitle, rate },
      },
    },
  },
}) => {
  return (
    <PageComponent
      cardName={cardTitle}
      handlers={[onAnalyseResultsClick ?? nextClickHandler, onDone]}
      title={title}
      locales={locales}
      text={text}
      footer={footer}
      header={header}
      stars={rate}
      name={name}
      test={test}
      titles={titles}
      menuItems={menuItems}
      selectComponent={selectComponent}
      componentIndex={componentIndex}
      rules={rules}
      backPath={backPath}
    />
  );
};

export default Sell;
